import { Inject, Injectable } from '@angular/core';
import TurndownService from 'turndown';
import { DOCUMENT } from '@angular/common';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarkdownService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  convert(html: string): string {
    const turndownService = new TurndownService();

    turndownService.addRule('mentions', {
      filter: (node, options) => {
        return (
          node.nodeName === 'SPAN' && node.getAttribute('data-denotation-char')
        );
      },
      replacement: (content, node, options) => {
        return node.getAttribute('data-denotation-char') === '@'
          ? `@[${node.getAttribute(
              'data-value'
            )}](mention://user/${node.getAttribute('data-id')})`
          : `#${node.getAttribute('data-value')}`;
      }
    });
    return turndownService.turndown(html);
  }

  convertMarkDownForDisplay(doc: string): string {
    if (!doc) return doc;

    let newDoc = doc;

    newDoc = this.replaceMentionToLinks(newDoc);
    // newDoc = this.replaceTagsWithId(newDoc);
    newDoc = this.replacePlainMentionTextToLink(newDoc);
    newDoc = this.replaceNormalHashTagToLinks(newDoc);

    return newDoc;
  }

  extractLastUrl(convertedBody: string): Observable<string> {
    const urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gim;

    let matches = [];
    let lastUrl = '';

    while ((matches = urlRegex.exec(convertedBody))) {
      if (matches) {
        lastUrl = matches[0];
      }
    }
    return of(lastUrl);
  }

  private replaceMentionToLinks(doc): string {
    const mentionsRegexp: RegExp = /@\[([\s\S]*?)]\(mention:\/\/user\/([a-z0-9]+)\)/gim;
    let newDoc = doc;
    let matches = [];

    while ((matches = mentionsRegexp.exec(doc))) {
      if (matches) {
        const hosts = window.location.origin;
        const mentionLink = `[${matches[1]}](mention://user/${matches[1]})`;

        newDoc = newDoc.replace(matches[0], mentionLink);
      }
    }
    return newDoc;
  }

  private replaceTagsWithId(doc): string {
    const mentionsRegexp: RegExp = /#\[([\s\S]*?)]\(hashtag:\/\/hash\/([a-z0-9]+)\)/gim;
    let newDoc = doc;
    let matches = [];

    while ((matches = mentionsRegexp.exec(doc))) {
      if (matches) {
        const hosts = window.location.origin;
        const hashLink = `[${matches[1]}](hashtag://tag/${matches[1]})`;
        newDoc = newDoc.replace(matches[0], hashLink);
      }
    }
    return newDoc;
  }

  private replaceNormalHashTagToLinks(doc): string {
    const normalHash: RegExp = /#([a-zA-Z0-9]+)/gim;

    let newDoc = doc;
    let matches = [];

    while ((matches = normalHash.exec(doc))) {
      if (matches) {
        const hashLink = `[${matches[1]}](hashtag://hash/${matches[1]})`;
        newDoc = newDoc.replace(matches[0], hashLink);
      }
    }

    return newDoc;
  }

  private replacePlainMentionTextToLink(doc): string {
    const normalMention: RegExp = /@([a-zA-Z0-9]+)/gim;

    let newDoc = doc;
    let matches = [];

    while ((matches = normalMention.exec(doc))) {
      if (matches) {
        const hashLink = `[${matches[1]}](mention://user/${matches[1]})`;
        newDoc = newDoc.replace(matches[0], hashLink);
      }
    }

    return newDoc;
  }
}
